<!--管理员列表-->
<template>
    <div style="line-height:normal;font-size: unset;">

        <!--<textarea v-model="contentCurrent" style="width: 0px; height: 0px;"></textarea>-->
        <!--<span @click="removeEditor">remove</span>-->
        <div>
            <!--{{contentCurrent}}-->
            <textarea :id="tinymceConfig.selector.replace('#','')" v-model="contentCurrent" @change="changeSelect">请输入内容</textarea>
            <!--<input type="text" v-model="contentCurrent"/>-->
            <!--<input type="button" value="提交" @click="changeSelect">-->
        </div>

        <!--<editor-->
        <!--v-if="loadSuccess"-->
        <!--:api-key="apiKey"-->
        <!--:init="tinymceConfig"-->
        <!--v-model="contentCurrent"-->
        <!--@change="changeSelect"-->
        <!--/>-->

    </div>
</template>
<script>


    //alert(tinymce)

    import formuiService from '../service/formui/FormuiService.js'

    import moment from 'moment'
    import ossService from '../service/base/OssService.js'
    var ScriptLoader_1 = require("./ScriptLoader.js");
    //订单类型
    export default {
        watch:{
            contentCurrent:function(newName, oldName){

//                    this.fullName = newName + ' ' + this.lastName;
//                    alert(222)
//                alert(this.fieldName+'__'+ this.contentCurrent)
                this.$emit('setFieldValue', this.fieldName, this.contentCurrent)
//                alert(2)
            }
        },
//        components: {
//            'editor': Editor
//        },
        name: 'OrderIsMainSelect',
        props: ['fieldContent','fieldName','disabled'],
        methods: {
            removeEditor:function(){
//                this.tinymce.remove()
                this.tinymce.remove(this.tinymceConfig.selector)
//                this.tinymce.remove()
            },
            changeSelect:function () {
                alert(22)
//                this.$emit('setFieldValue', this.fieldName, this.contentCurrent)
            },
            imagesUploadHandler: function(blobInfo, success, failure) {
                let that=this
                let formdata = new FormData();
                formdata.append("file", blobInfo.blob());
                // 上传图片接口，跟后端同事协调上传图片
                // http://hh.xxxx.cn/admin/upload为上传图片接口
//                axios.post('http://hh.xxxx.cn/admin/upload',formdata)
//                    .then(function(res) {
//                        success(res.data.data.src);
//                    }).catch(res => {
//                    failure("error");
//                });
//console.log(blobInfo.filename())
//                return;
                ossService.ostObjectPolicy(that,{
//        'dir': window.UEDITOR_CONFIG.OSSDIR,
                    'dir': 'formui',
                    'srcname': blobInfo.filename()
                },function (resp) {
//                                            alert(22)
                    var sign = resp;
                    var form = new FormData();
//                                            var object_name = "" + window.UEDITOR_CONFIG.OSSDIR + "";
// 添加签名信息
                    form.append('OSSAccessKeyId', sign['accessid']);
                    form.append('policy', sign['policy']);
                    form.append('Signature', sign['signature']);
                    form.append('key', sign['key']);
// 添加文件
                    form.append('file', blobInfo.blob())
                    // alert(1);

                    that.$http.post(sign['host'], form).then(res => {
//                                                console.log(res.data);
//                                                alert(1)
                        if (res) {

//                                                    let imgUrl = res.data.result.file_url
                            let imgUrl=sign['hostGet']+'/'+sign['key']
//                                                    alert(imgUrl)
//                                                    let picPath = service.baseUrl + imgUrl;
//                            let length = self.quill.getSelection(true).index;
                            //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
//                            self.quill.insertEmbed(length, 'image', imgUrl);
//                            self.quill.setSelection(length + 1)
                            success(imgUrl);
                        }
                    })
                })


            }

            ,initInstanceCallback:function(editor){
//                        alert(234)
                let that=this
                editor.on('input', (e) => {
//                            alert(1)
                    that.contentCurrent = tinyMCE.activeEditor.getContent();

                });
                editor.on('paste', (e) => {
//                            alert(2)
                    that.contentCurrent = tinyMCE.activeEditor.getContent();

                });

                editor.on('ExecCommand', (e) => {

                    that.contentCurrent = tinyMCE.activeEditor.getContent();
                });

                editor.on('keyup', (e) => {
                    that.contentCurrent = tinyMCE.activeEditor.getContent();

                });

            }

        },

        data () {
            return {
                tinymce:null,
                editor:null,
                contentCurrent:'',
                editorOption:{},
                tinymceConfig:{
                    readonly:this.disabled,
                    selector: '#tinymce-editor'+Math.ceil(Math.random()*100),//+Math.ceil(Math.random()*100)
                    height: 500, //富文本高度
                    language_url: '//oss.vistastory.com/web/plugin/tinymce/langs/zh_CN.js', //中文包
                    language: 'zh_CN', //中文
                    browser_spellcheck: true, // 拼写检查
                    branding: false, // 去水印
                    elementpath: true, //禁用编辑器底部的状态栏
                    statusbar: true, // 隐藏编辑器底部的状态栏
                    paste_data_images: true, // 是否允许粘贴图像
                    menubar: true, // 隐藏最上方menu
                    fontsize_formats: '14px 16px 18px 20px 24px 26px 28px 30px 32px 36px', //字体大小
                    font_formats:'微软雅黑=Microsoft YaHei,Helvetica Neue;PingFang SC;sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun;serifsans-serif;Terminal=terminal;monaco;Times New Roman=times new roman;times', //字体
                    file_picker_types: 'image',
                    images_upload_credentials: true,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                        'formatpainter'
                    ],
                    toolbar: 'code fontselect fontsizeselect link lineheight forecolor backcolor bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | image quicklink h2 h3 blockquote table numlist bullist preview fullscreen formatpainter',
                    // 图片上传三个参数，图片数据，成功时的回调函数，失败时的回调函数
                    images_upload_handler: this.imagesUploadHandler,
                    init_instance_callback: this.initInstanceCallback,
//                    extended_valid_elements : 'div[onclick]',
                    extended_valid_elements : 'div[onclick|id|style|class],img[onclick|id|style|class|alt|width|height|border|name|src],span[onclick|id|style|class]',
                    custom_elements:'script,style',
//                    convert_fonts_to_spans : false,// 转换字体元素为SPAN标签，默认为true
                },
                loadSuccess:false,
                isCode:0,

            }
        },
        created () {
            let that = this



//            this.that=this
            if(this.fieldContent){
//                alert(this.fieldValue)
                this.contentCurrent=this.fieldContent

            }

            this.loadSuccess=true
        },
        mounted(){
//            alert(1)
            let that=this

            if(window.tinymce){
                that.tinymce=window.tinymce
////                alert(22)
                that.editor=that.tinymce.init(that.tinymceConfig)
            }else{
//                alert(2)

//            alert( that.editor)
                ScriptLoader_1.ScriptLoader.load(document,'//oss.vistastory.com/web/plugin/tinymce/tinymce.min.js',function () {
                    that.tinymce=tinymce
                    that.editor=that.tinymce.init(that.tinymceConfig)
                    const formatpainter= import('tinymce-plugin-formatpainter')
                    console.log(formatpainter)

                })
            }

        },
        beforeDestroy (){
            let that=this
            this.tinymce.execCommand('mceRemoveEditor', true, this.tinymceConfig.selector.replace('#',''));

        }


    }
</script>

<style>
.v-modal {
    z-index: 200 !important;
}
.table-dialog .el-dialog__wrapper{z-index: 230 !important;}
</style>


// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/widget/FormUiRichText.vue